import React from 'react';
import { useDispatch } from 'react-redux';
import { TaxTraxResult } from '../../models';
import { Divider, Card, Typography, Table, Button } from 'antd';
import { PropertyAddress, PropertyOwner } from 'pages/common/models';
import { fetchTaxBillsAsync } from 'pages/TaxTrax';
import { CommonTable } from 'common';
import { Property } from 'common/models';
import { useAccount, useMsal } from '@azure/msal-react';
import { getAccessToken } from 'common/helpers';
import { InteractionStatus } from '@azure/msal-browser';

const { Title, Text } = Typography;
const { Column } = Table;

const TaxTraxPropertiesTable: React.FC<{
  data: TaxTraxResult;
}> = (props: { data: TaxTraxResult }) => {
  const dispatch = useDispatch();
  const { data } = props;
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const fetchTaxBills = (record: Property) => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(fetchTaxBillsAsync(record, response.accessToken));
      });
    }
  };

  return (
    <>
      <Divider dashed />
      <Card size="small">
        <Title>Reports</Title>
        <CommonTable items={data.properties} rowKey="apn">
          <Column
            width="17rem"
            title="ADDRESS"
            dataIndex="addresses"
            render={(record: PropertyAddress[]) =>
              record.map((address: PropertyAddress, index: number) => {
                return (
                  <React.Fragment key={`propertyAddress${index}`}>
                    <Text>
                      {`${address.houseNumber} ${address.street}${
                        address.streetUnit || address.city ? ',' : ''
                      } ${address.streetUnit} ${address.city}`}
                    </Text>
                    <br />
                  </React.Fragment>
                );
              })
            }
          />
          <Column
            width="11rem"
            title="OWNER"
            dataIndex="owners"
            render={(record: PropertyOwner[]) =>
              record.map((owner: PropertyOwner, index: number) => {
                return (
                  <React.Fragment key={`propertyOwner${index}`}>
                    <Text>{owner.name}</Text>
                    <br />
                  </React.Fragment>
                );
              })
            }
          />
          <Column
            title="PROPERTY ID"
            dataIndex="property-id"
            width="18rem"
            render={(
              _,
              {
                county,
                section,
                sheet,
                block,
                lot,
                lotSuf,
                leadLot,
                district,
                ca,
                unit,
                addLot,
                item,
              }: any,
            ) => {
              return (
                <>
                  <Text strong>County: </Text>
                  <Text>{county} </Text>
                  {district && (
                    <>
                      <Text strong>District: </Text>
                      <Text>{district} </Text>
                    </>
                  )}
                  {section && (
                    <>
                      <Text strong>Section: </Text>
                      <Text>{section} </Text>
                    </>
                  )}
                  {sheet && (
                    <>
                      <Text strong>Sheet: </Text>
                      <Text>{sheet} </Text>
                    </>
                  )}
                  <Text strong>Block: </Text>
                  <Text>{block} </Text>
                  {lot && (
                    <>
                      <Text strong>Lot: </Text>
                      <Text>{lot} </Text>
                    </>
                  )}
                  {ca && (
                    <>
                      <Text strong>CA: </Text>
                      <Text>{ca} </Text>
                    </>
                  )}
                  {unit && (
                    <>
                      <Text strong>Unit: </Text>
                      <Text>{unit} </Text>
                    </>
                  )}
                  {lotSuf && (
                    <>
                      <Text strong>Lot Sufix: </Text>
                      <Text>{lotSuf} </Text>
                    </>
                  )}
                  {leadLot && (
                    <>
                      <Text strong>Lead Lot: </Text>
                      <Text>{leadLot} </Text>
                    </>
                  )}
                  {addLot && (
                    <>
                      <Text strong>Add Lot: </Text>
                      <Text>{addLot} </Text>
                    </>
                  )}
                  {item && (
                    <>
                      <Text strong>Item: </Text>
                      <Text>{item} </Text>
                    </>
                  )}
                </>
              );
            }}
          />
          <Column
            title="Select"
            width="11rem"
            render={(record: Property) => (
              <Button
                type="link"
                size="small"
                icon="more"
                onClick={() => fetchTaxBills(record)}
                title="Property Details"
              >
                Property Details
              </Button>
            )}
          />
        </CommonTable>
      </Card>
    </>
  );
};

export default TaxTraxPropertiesTable;
